import { IOptionPickerItem } from '@vfde-brix/ws10/option-picker';
import { Gigakombi, ProductType } from '../../enum';
import { Customer } from '@vfde-sails/login';
import { ProductContainerProps } from '../../container/Product';

/**
 * Update gigakombi picker item's properties based on state values
 */
const getGigakombiPickerItem = (item: IOptionPickerItem, selected: Gigakombi, customer?: Customer) => {
    item.optChecked = selected === item.stdValue;

    if (!customer) {
        item.optDisabled = false;

        return item;
    }

    switch (item.stdValue) {
        case Gigakombi.NONE:
            item.optDisabled = customer.hasKipContract;
            break;
        case Gigakombi.INTERNET:
            item.optDisabled = !customer.hasKipContract;
            break;
    }

    return item;
};

export const getProductPickerItem = (item: IOptionPickerItem, props: ProductContainerProps) => {
    item.optChecked = item.stdValue === props.selected.type;

    if (props.isBookingDisabled || props.isNonMonthlyBilling || props.hasTvContract) {
        item.optDisabled = false;

        return item;
    }

    switch (item.stdValue) {
        case ProductType.CABLE:
            item.optDisabled = !props.productAvailability.cableTv;
            break;
        case ProductType.NET:
            item.optDisabled = !props.productAvailability.netTv;
            break;
    }

    return item;
};

export default {
    getGigakombiPickerItem,
    getProductPickerItem,
};
